import { gql } from '@apollo/client';

export const GET_TASK_CONTENT_LIBRARY = gql`
  query getTaskContentLibrary($limit: Float, $offset: Float, $question: String!) {
    getRowsFromSimilarQuestionsTenjin(query: { offset: $offset, limit: $limit, question: $question }) {
      rows {
        id
        question
        answer
      }
      totalCount
    }
  }
`;
